import { render, staticRenderFns } from "./mySelectList.vue?vue&type=template&id=3b8d41e0&"
import script from "./mySelectList.vue?vue&type=script&lang=js&"
export * from "./mySelectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports